import { Component, EventEmitter, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Preventivo, VocePolizza } from '../shared/preventivo';

@Component({
  selector: 'app-step2',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './step2.html',
  styleUrl: './step2.css'
})
export class Step2 {
  @Output() avanti = new EventEmitter<void>();

  mostraPopup = false;

  nuovaVoce: VocePolizza | null = null;
  massimale: number | null = null;

  constructor(private preventivoService: Preventivo) {}

  get voci(): VocePolizza[] {
    return this.preventivoService.getVoci();
  }

  apriPopupNuovaVoce() {
    if (this.nuovaVoce !== null || this.voci.length >= 40) return;

    this.nuovaVoce = {
      etichetta: '',
      targa: '',
      tipoPatente: '',
      diaria: null as any,
      giorni: null as any,
      coperture: [
        'Tutela Legale Ritiro Patente',
        'Perdite Pecunarie',
        'Diaria per Sospensione di Guida'
      ]
    };
    this.mostraPopup = true;
  }

  chiudiPopup() {
    this.mostraPopup = false;
  }

  salvaNuovaVoce() {
    if (this.nuovaVoce) {
      this.preventivoService.addVoce({ ...this.nuovaVoce });
      this.nuovaVoce = null;
    }
  }

  rimuoviVoce(index: number) {
    this.preventivoService.removeVoce(index);
  }

  avantiStep() {
    this.preventivoService.setMassimale(this.massimale ?? 0);
    this.avanti.emit();
  }
}
